import React, { useState } from 'react';
import { Row, Col, Container, Form } from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import DataTable from 'react-data-table-component';
import { SelectInput, TextInput } from '../Helpers/Inputs';
import { Modal } from 'react-bootstrap';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import NumberFormat from 'react-number-format';
import "./UploadFileModal.scss";
import { AdvisorCaseType } from '../Helpers/Constants/CaseType';

export default function UploadFileModal(props) {

    const { caseId, typeId, selectedCaseDetails, handleClose, show, filesToUpload, setFilesToUpload, fileData, setFileData, submitFiles ,setError } = props;

    const [error, displayError] = useState("");
    const [uploadAs, setUploadAs] = useState(2);
    const [uploadCarrierName, setUploadCarrierName] = useState('');

    const uploadDocumentTypesOptions = () => {
        return [
            { value: 2, label: 'Illustration' },
            { value: 12, label: 'Application' },
            { value: 50, label: 'Institution Form' },
            { value: 51, label: 'Policy Contract' }
        ];
    }

    const changeHandlerModal = (event) => {
        displayError("");
        if (event.target.files[0] === undefined) {
            event.target.value = "";
            return;
        }
        const file = event.target.files[0];
        let fileSize = event.target.files[0].size;
        let fileName = event.target.files[0].name;

        let sameName = false;
        filesToUpload.forEach((element, index) => {
            if (element.fileName === fileName) {
                sameName = true;
            }
        })

        if (sameName) {
            displayError("Same file upload is not allowed.");
            event.target.value = "";
            return;
        }

        let acceptedExtension = ["pdf", "mtiff", "tif", "tiff"];
        let extension = fileName.split('.').pop();

        if (Number(fileSize) > 20971520) {
            displayError("File with maximum size of 20MB can be uploaded.");
            event.target.value = "";
            return;
        }
        if (!acceptedExtension.includes(extension.toLowerCase())) {
            displayError("Only files with extensions .pdf, .tif, .tiff, .mtiff are allowed.");
            event.target.value = "";
            return;
        }

        const options = uploadDocumentTypesOptions();
        const fileType = options.find(x => x.value === Number(uploadAs)).label;

        if (typeId !== AdvisorCaseType.ILLUSTRATIONREQUESTCASE) {
            file.entityID = caseId;
            file.imageEntityType = typeId;
            file.imageTypeID = Number(uploadAs);
            file.shared = false;
            file.sendToFunder = false;
            file.fileName = fileName;
            file.carrierName = uploadCarrierName === '' ? null : uploadCarrierName;
            file.fileType = fileType;
        }
        else {
            file.IllustrationRequestID = caseId;
            file.imageTypeID = Number(uploadAs);
            file.Publish = true;
            file.fileName = fileName;
            file.carrierName = uploadCarrierName === '' ? null : uploadCarrierName;
            file.fileType = fileType;
        }

        const fileList = filesToUpload;
        fileList.push(file);
        setFilesToUpload([...fileList]);

        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (err) => {
                reject(err);
            };

            reader.readAsDataURL(file);
        }).then((data) => {
            const fileDataCopy = fileData;
            fileDataCopy.push(data);
            setFileData([...fileDataCopy])
        });
        event.target.value = "";
    }

    const closeHandler = () => {
        setFileData([]);
        setFilesToUpload([]);
        setUploadCarrierName('');
        displayError('');
        handleClose();
    }

    const submitHandler = () => {
        displayError('');
        setUploadCarrierName('');
        submitFiles();
    }

    const modalTableColumn = [
        {
            name: 'Name',
            cell: row => <div title={row.name}>{row.name}</div>,
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Type',
            cell: row => <div className="rowType">{row.fileType}</div>,
            selector: row => row.fileType,
            sortable: true,
        },
        {
            name: 'Carrier',
            cell: row => <div title={row.carrierName}>{row.carrierName}</div>,
            selector: row => row.carrierName,
            sortable: true,
        },
    ]

    return (
        <Modal className="upload-file-modal" show={show} onHide={closeHandler} animation={false} centered>
          <Modal.Body className="show-grid">
            <Container>
              <Row className="modal-design pt-8">
                <div className="upload-text pl-0">Upload Document</div>
                <div className="close-icon-section">
                   <IconButton className="close-button" aria-label="close" onClick={closeHandler}>
                        <CloseIcon />
                   </IconButton>
                </div>
              </Row>
              <Row>
               <Col>
                <div>
                    <p className='pb-2 pt-2'>Term Life Insurance - {selectedCaseDetails.faceAmount ? <NumberFormat displayType={'text'} prefix={'$'} value={selectedCaseDetails.faceAmount} thousandSeparator={true} /> : 'Coverage Amount Unknown'} - {selectedCaseDetails.carrier || 'Carrier Unknown'}</p>
                 </div>
               </Col>
              </Row>
              <Row className="content-spacing">
                <Col lg={10}>
                  <Form.Group>
                    <SelectInput
                      name="uploadAs"
                      id="uploadAs"
                      value={uploadAs}
                      onChange={(e) => setUploadAs(e.target.value)}
                      label="Upload File As"
                      selectOptions={uploadDocumentTypesOptions()}
                    />
                    </Form.Group>
                    </Col>
              </Row>
               <Row>
                 <Col lg={10}>
                    <Form.Group>
                       <TextInput
                         name="uploadCarrierName"
                         id="uploadCarrierName"
                         label="(Optional) Add a Carrier Name"
                         value={uploadCarrierName}
                         onChange={e => setUploadCarrierName(e.target.value)}
                        />
                    </Form.Group>
                 </Col>
               </Row>
                <Row>
                <Col lg={10}>
                        <label htmlFor="text-button-file" className="mb-4">
                            <input className="d-none" id="text-button-file" type="file" onChange={changeHandlerModal} />
                            <Button className='text-center py-1 px-4' disabled={uploadAs === ''} variant="outlined" type="button" color="primary" component="span">SELECT FILE</Button>
                        </label>
                </Col>
                </Row>

                <Row className="justify-content-center mb-3 px-5">
                  { setError && <div className='MuiFormHelperText-root MuiFormHelperText-contained Mui-error'>{setError} </div> }
                    <div className='MuiFormHelperText-root MuiFormHelperText-contained Mui-error'>{error}</div>
                </Row>

                <Row className="mt-1">
                 <DataTable
                   columns={modalTableColumn}
                   data={filesToUpload}
                   persistTableHead
                   fixedHeader
                   fixedHeaderScrollHeight="10em"
                    />
                </Row>
               <Row className="content-spacing">
              <Col className="d-flex justify-content-between">
              <div className="buttons-spacing">
              <Button
                 className='text-center btn-continue py-1 px-4'
                 variant="outlined"
                 size="large"
                 type="submit"
                 color="primary"
                 onClick={() => closeHandler()}
                >
                CANCEL
                </Button>
               </div>
                <div className="buttons-spacing">
                 <Button
                     className='text-center btn-continue py-1 px-5'
                     variant="contained"
                     size="large"
                     type="submit"
                     color="primary"
                     onClick={() => submitHandler()}
                  >
                      SAVE
                  </Button>
                 </div>
              </Col>
                </Row>
            </Container>
           </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/Common/UploadFileModal.js